import script from "./Bubble.vue?vue&type=script&setup=true&lang=js"
export * from "./Bubble.vue?vue&type=script&setup=true&lang=js"

import "./Bubble.vue?vue&type=style&index=0&id=a95b067a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a95b067a"]])

export default __exports__